import { useState, useEffect, useRef } from "react";
const VisibleHook = (props) => {
  const { visible, time } = props;
  const contentRef = useRef();
  const containerRef = useRef();
  const [containerVisible, setContainerVisible] = useState(visible);
  const [contentVisible, setContentrVisible] = useState(false);
  useEffect(() => {
    if (visible) {
      clearTimeout(containerRef.current);
      setContainerVisible(true);
      // contentRef.current = setTimeout(() => {
      setContentrVisible(true);
      // }, 1);
    } else {
      clearTimeout(contentRef.current);
      containerRef.current = setTimeout(() => {
        setContentrVisible(false);
        setContainerVisible(false);
      }, time || 300);
    }
  }, [visible]);
  return {
    containerVisible,
    contentVisible,
  };
};

export default VisibleHook;
